/**
 * Maps state FIPS codes to arrays of NWS office IDs responsible for
 * weather stories in that state. Ordered by priority — primary office first.
 * States with large areas get multiple offices so that if the primary
 * office has no active weather stories, fallback offices are tried.
 */
const STATE_OFFICE_MAP = {
  '01': ['BMX', 'MOB', 'HUN'],        // Alabama → Birmingham, Mobile, Huntsville
  '02': ['AFC', 'AFG', 'AJK'],        // Alaska → Anchorage, Fairbanks, Juneau
  '04': ['PSR', 'FGZ', 'TWC'],        // Arizona → Phoenix, Flagstaff, Tucson
  '05': ['LZK'],                       // Arkansas → Little Rock
  '06': ['LOX', 'SGX', 'STO', 'MTR', 'HNX', 'EKA'],  // California → LA, San Diego, Sacramento, SF Bay, Hanford, Eureka
  '08': ['BOU', 'GJT', 'PUB'],        // Colorado → Boulder, Grand Junction, Pueblo
  '09': ['OKX'],                       // Connecticut → New York
  '10': ['PHI'],                       // Delaware → Philadelphia
  '11': ['LWX'],                       // DC → Baltimore/Washington
  '12': ['MFL', 'JAX', 'TBW', 'TAE', 'MLB', 'KEY'],  // Florida → Miami, Jacksonville, Tampa, Tallahassee, Melbourne, Key West
  '13': ['FFC', 'JAX'],               // Georgia → Peachtree City, Jacksonville
  '15': ['HFO'],                       // Hawaii → Honolulu
  '16': ['BOI'],                       // Idaho → Boise
  '17': ['ILX', 'LOT'],               // Illinois → Lincoln, Chicago
  '18': ['IND', 'IWX'],               // Indiana → Indianapolis, Northern Indiana
  '19': ['DMX'],                       // Iowa → Des Moines
  '20': ['TOP', 'ICT', 'DDC', 'GLD'], // Kansas → Topeka, Wichita, Dodge City, Goodland
  '21': ['LMK', 'JKL', 'PAH'],        // Kentucky → Louisville, Jackson, Paducah
  '22': ['LIX', 'LCH', 'SHV'],        // Louisiana → New Orleans, Lake Charles, Shreveport
  '23': ['GYX', 'CAR'],               // Maine → Gray/Portland, Caribou
  '24': ['LWX', 'PHI'],               // Maryland → Baltimore/Washington, Philadelphia
  '25': ['BOX'],                       // Massachusetts → Boston
  '26': ['DTX', 'GRR', 'APX', 'MQT'], // Michigan → Detroit, Grand Rapids, Gaylord, Marquette
  '27': ['MPX', 'DLH'],               // Minnesota → Twin Cities, Duluth
  '28': ['JAN'],                       // Mississippi → Jackson
  '29': ['LSX', 'SGF', 'EAX'],        // Missouri → St. Louis, Springfield, Kansas City
  '30': ['TFX', 'MSO', 'GGW', 'BYZ'], // Montana → Great Falls, Missoula, Glasgow, Billings
  '31': ['OAX', 'LBF', 'GID'],        // Nebraska → Omaha, North Platte, Hastings
  '32': ['VEF', 'LKN', 'REV'],        // Nevada → Las Vegas, Elko, Reno
  '33': ['GYX'],                       // New Hampshire → Gray/Portland
  '34': ['PHI', 'OKX'],               // New Jersey → Philadelphia, New York
  '35': ['ABQ'],                       // New Mexico → Albuquerque
  '36': ['OKX', 'ALY', 'BUF', 'BGM'], // New York → NYC, Albany, Buffalo, Binghamton
  '37': ['RAH', 'ILM', 'MHX', 'GSP'], // North Carolina → Raleigh, Wilmington, Morehead City, Greenville-Spartanburg
  '38': ['BIS', 'FGF'],               // North Dakota → Bismarck, Grand Forks
  '39': ['ILN', 'CLE', 'PBZ'],        // Ohio → Wilmington, Cleveland, Pittsburgh
  '40': ['OUN', 'TSA'],               // Oklahoma → Norman, Tulsa
  '41': ['PQR', 'MFR', 'PDT'],        // Oregon → Portland, Medford, Pendleton
  '42': ['CTP', 'PHI', 'PBZ'],        // Pennsylvania → State College, Philadelphia, Pittsburgh
  '44': ['BOX'],                       // Rhode Island → Boston
  '45': ['CAE', 'CHS', 'GSP'],        // South Carolina → Columbia, Charleston, Greenville-Spartanburg
  '46': ['FSD', 'ABR', 'UNR'],        // South Dakota → Sioux Falls, Aberdeen, Rapid City
  '47': ['OHX', 'MRX', 'MEG'],        // Tennessee → Nashville, Morristown, Memphis
  '48': ['FWD', 'HGX', 'EWX', 'LUB', 'AMA', 'MAF', 'SJT', 'BRO', 'CRP', 'EPZ'],  // Texas → major offices
  '49': ['SLC'],                       // Utah → Salt Lake City
  '50': ['BTV'],                       // Vermont → Burlington
  '51': ['AKQ', 'LWX', 'RNK'],        // Virginia → Wakefield, Baltimore/Washington, Blacksburg
  '53': ['SEW', 'OTX', 'PDT'],        // Washington → Seattle, Spokane, Pendleton
  '54': ['RLX', 'PBZ'],               // West Virginia → Charleston, Pittsburgh
  '55': ['MKX', 'GRB', 'ARX'],        // Wisconsin → Milwaukee, Green Bay, La Crosse
  '56': ['RIW', 'CYS'],               // Wyoming → Riverton, Cheyenne
  '72': ['SJU'],                       // Puerto Rico → San Juan
};

export default STATE_OFFICE_MAP;
